module.exports = __webpack_public_path__ + "static/5-05ad8e4d35643d3ce41f505530328498.jpg";